<template>
  <router-view />
</template>

<style src="./app.scss" lang="scss"></style>
